import { CookiePolicy } from '../../policies/cookie-policy/cookie-policy';

export const CookiePolicyPage = () => <CookiePolicy />;
